var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AngularFireAuth } from '@angular/fire/auth';
import { OnInit } from '@angular/core';
export class PasswordResetPageComponent {
    constructor(auth, route) {
        this.auth = auth;
        this.route = route;
        this.submitted = false;
        this.submitError = false;
        this.form = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.email])
        });
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    sendResetMail() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.form.valid) {
                return;
            }
            const email = this.form.value.email;
            try {
                yield this.auth.auth.sendPasswordResetEmail(email);
                this.submitted = true;
            }
            catch (e) {
                // alert(e);
                this.submitError = true;
            }
        });
    }
}
